import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, withCtx as _withCtx, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createBlock as _createBlock, resolveDynamicComponent as _resolveDynamicComponent, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "ll-hero relative overflow-hidden" }
const _hoisted_2 = { class: "mx-auto max-w-7xl px-6 lg:px-8 pt-16 pb-16 lg:pt-20" }
const _hoisted_3 = { class: "grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-8 items-center" }
const _hoisted_4 = { class: "shadow inline-flex items-center rounded-full bg-white px-4 py-2 mb-6 text-base font-medium text-gray-600 ring-1 ring-gray-500/10 ring-inset" }
const _hoisted_5 = { class: "text-5xl font-semibold tracking-tight text-pretty text-gray-900 sm:text-6xl" }
const _hoisted_6 = { class: "ll-hl not-italic text-teal-600 whitespace-nowrap relative" }
const _hoisted_7 = { class: "mt-8 text-lg font-medium text-pretty text-gray-500 sm:text-xl/8 max-w-xl" }
const _hoisted_8 = { class: "mt-8 flex flex-wrap items-center gap-4" }
const _hoisted_9 = ["href"]
const _hoisted_10 = {
  href: "#como-funciona",
  class: "inline-block rounded-xl border border-gray-200 bg-white px-7 py-3 shadow-sm text-center font-semibold text-gray-700 hover:border-gray-300 hover:text-gray-900 transition-all duration-200"
}
const _hoisted_11 = { class: "mt-6 flex flex-wrap items-center gap-x-2 gap-y-1 text-sm text-gray-500 font-medium" }
const _hoisted_12 = { class: "inline-flex items-center gap-1.5 font-semibold text-gray-700" }
const _hoisted_13 = {
  class: "ll-hero-visual",
  "aria-hidden": "true"
}
const _hoisted_14 = { class: "ll-phone" }
const _hoisted_15 = { class: "ll-live-topbar" }
const _hoisted_16 = { class: "ll-live-pill" }
const _hoisted_17 = { class: "ll-comments" }
const _hoisted_18 = { class: "ll-c-body" }
const _hoisted_19 = { class: "ll-report-card" }
const _hoisted_20 = { class: "ll-report-head" }
const _hoisted_21 = { class: "ll-vis-title" }
const _hoisted_22 = { class: "ll-pill-teal" }
const _hoisted_23 = { class: "ll-report-stats" }
const _hoisted_24 = { class: "ll-rstat" }
const _hoisted_25 = { class: "ll-rstat" }
const _hoisted_26 = { class: "ll-rstat" }
const _hoisted_27 = {
  class: "ll-report-row",
  style: {"animation-delay":".8s"}
}
const _hoisted_28 = { class: "ll-r-tx" }
const _hoisted_29 = {
  class: "ll-report-row",
  style: {"animation-delay":"1.6s"}
}
const _hoisted_30 = { class: "ll-r-tx" }
const _hoisted_31 = { class: "ll-r-badge ll-bg-teal" }
const _hoisted_32 = {
  class: "ll-report-row",
  style: {"animation-delay":"2.4s"}
}
const _hoisted_33 = { class: "ll-r-tx" }
const _hoisted_34 = { class: "ll-r-badge ll-bg-violet" }
const _hoisted_35 = {
  class: "ll-report-row",
  style: {"animation-delay":"3.2s"}
}
const _hoisted_36 = { class: "ll-r-tx" }
const _hoisted_37 = { class: "ll-dm-chip" }
const _hoisted_38 = { class: "ll-dm-tx" }
const _hoisted_39 = { class: "bg-gray-50 border-y border-gray-200" }
const _hoisted_40 = { class: "mx-auto max-w-7xl px-6 lg:px-8 py-20" }
const _hoisted_41 = { class: "ll-reveal text-center text-3xl font-semibold tracking-tight text-gray-900 max-w-2xl mx-auto" }
const _hoisted_42 = { class: "mt-12 grid grid-cols-2 lg:grid-cols-4 gap-4" }
const _hoisted_43 = { class: "text-4xl font-semibold tracking-tight text-teal-600 tabular-nums" }
const _hoisted_44 = ["data-target", "data-decimals", "data-suffix"]
const _hoisted_45 = { class: "mt-2 text-sm text-gray-500 font-medium" }
const _hoisted_46 = {
  id: "como-funciona",
  class: "mx-auto max-w-7xl px-6 lg:px-8 py-24 text-center"
}
const _hoisted_47 = { class: "ll-reveal ll-section-tag" }
const _hoisted_48 = { class: "ll-reveal text-4xl font-semibold tracking-tight text-pretty text-gray-900 sm:text-5xl" }
const _hoisted_49 = { class: "ll-reveal mt-6 text-lg/8 text-gray-600 max-w-2xl mx-auto" }
const _hoisted_50 = { class: "mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 text-left" }
const _hoisted_51 = { class: "ll-step-num" }
const _hoisted_52 = { class: "text-lg font-semibold text-gray-900 mb-1.5" }
const _hoisted_53 = { class: "text-sm text-gray-500" }
const _hoisted_54 = { class: "ll-reveal ll-livvia-strip" }
const _hoisted_55 = { class: "text-left" }
const _hoisted_56 = { class: "ll-livvia-name block text-xs font-semibold mb-1" }
const _hoisted_57 = ["innerHTML"]
const _hoisted_58 = {
  id: "recursos",
  class: "bg-gray-50 border-y border-gray-200"
}
const _hoisted_59 = { class: "mx-auto max-w-7xl px-6 lg:px-8 py-24" }
const _hoisted_60 = { class: "text-center" }
const _hoisted_61 = { class: "ll-reveal ll-section-tag" }
const _hoisted_62 = { class: "ll-reveal text-4xl font-semibold tracking-tight text-pretty text-gray-900 sm:text-5xl" }
const _hoisted_63 = { class: "ll-reveal mt-6 text-lg/8 text-gray-600 max-w-2xl mx-auto" }
const _hoisted_64 = { class: "ll-spot ll-reveal ll-spot-anim" }
const _hoisted_65 = { class: "ll-spot-kicker ll-kick-teal" }
const _hoisted_66 = { class: "ll-desc" }
const _hoisted_67 = { class: "ll-checks" }
const _hoisted_68 = { class: "ll-vis-panel" }
const _hoisted_69 = { class: "ll-vis-head" }
const _hoisted_70 = { class: "ll-vis-title" }
const _hoisted_71 = { class: "ll-pill-teal" }
const _hoisted_72 = { class: "ll-vis-tabs" }
const _hoisted_73 = { class: "ll-vis-tab ll-on" }
const _hoisted_74 = { class: "ll-vis-tab" }
const _hoisted_75 = { class: "ll-vis-tab" }
const _hoisted_76 = {
  class: "ll-bars",
  "aria-hidden": "true"
}
const _hoisted_77 = ["data-peak"]
const _hoisted_78 = { class: "ll-msg-feed" }
const _hoisted_79 = { class: "ll-msg-row" }
const _hoisted_80 = { class: "ll-m-tag ll-kick-teal" }
const _hoisted_81 = { class: "ll-msg-row" }
const _hoisted_82 = { class: "ll-m-tag ll-kick-amber" }
const _hoisted_83 = { class: "ll-msg-row" }
const _hoisted_84 = { class: "ll-m-tag ll-kick-teal" }
const _hoisted_85 = { class: "ll-spot ll-flip ll-reveal ll-spot-anim" }
const _hoisted_86 = { class: "ll-spot-kicker ll-kick-pink" }
const _hoisted_87 = { class: "ll-desc" }
const _hoisted_88 = { class: "ll-checks" }
const _hoisted_89 = { class: "ll-vis-panel" }
const _hoisted_90 = { class: "ll-vis-head" }
const _hoisted_91 = { class: "ll-vis-title" }
const _hoisted_92 = { class: "ll-pill-pink" }
const _hoisted_93 = { class: "ll-flow" }
const _hoisted_94 = { class: "ll-f-el ll-f-comment" }
const _hoisted_95 = { class: "ll-f-bub" }
const _hoisted_96 = { class: "ll-f-el ll-f-cart" }
const _hoisted_97 = { class: "ll-fc-head" }
const _hoisted_98 = { class: "ll-fc-badge" }
const _hoisted_99 = { class: "ll-f-item" }
const _hoisted_100 = { class: "ll-f-item" }
const _hoisted_101 = { class: "ll-f-total" }
const _hoisted_102 = { class: "ll-f-el ll-f-dm" }
const _hoisted_103 = { class: "ll-f-dm-bub" }
const _hoisted_104 = { class: "ll-f-ck" }
const _hoisted_105 = { class: "ll-f-el ll-f-note" }
const _hoisted_106 = { class: "ll-kw-chips" }
const _hoisted_107 = { class: "ll-kw-chip" }
const _hoisted_108 = { class: "ll-kw-chip" }
const _hoisted_109 = { class: "ll-kw-chip" }
const _hoisted_110 = { class: "ll-spot ll-reveal ll-spot-anim" }
const _hoisted_111 = { class: "ll-spot-kicker ll-kick-violet" }
const _hoisted_112 = { class: "ll-desc" }
const _hoisted_113 = { class: "ll-checks" }
const _hoisted_114 = { class: "ll-vis-panel" }
const _hoisted_115 = { class: "ll-vis-head" }
const _hoisted_116 = { class: "ll-vis-title" }
const _hoisted_117 = { class: "ll-pill-violet" }
const _hoisted_118 = { class: "ll-player" }
const _hoisted_119 = {
  class: "ll-wv",
  "aria-hidden": "true"
}
const _hoisted_120 = { class: "ll-tline ll-tl1" }
const _hoisted_121 = ["innerHTML"]
const _hoisted_122 = { class: "ll-tline ll-tl2" }
const _hoisted_123 = ["innerHTML"]
const _hoisted_124 = { class: "ll-tline ll-tl3" }
const _hoisted_125 = ["innerHTML"]
const _hoisted_126 = { class: "ll-ia-chips" }
const _hoisted_127 = { class: "ll-ia-chip ll-kick-violet" }
const _hoisted_128 = { class: "ll-ia-chip ll-kick-amber" }
const _hoisted_129 = { class: "ll-spot ll-flip ll-reveal ll-spot-anim" }
const _hoisted_130 = { class: "ll-spot-kicker ll-kick-blue" }
const _hoisted_131 = { class: "ll-desc" }
const _hoisted_132 = { class: "ll-checks" }
const _hoisted_133 = { class: "ll-vis-panel" }
const _hoisted_134 = { class: "ll-vis-head" }
const _hoisted_135 = { class: "ll-vis-title" }
const _hoisted_136 = { class: "ll-pill-blue" }
const _hoisted_137 = { class: "ll-kpis" }
const _hoisted_138 = { class: "ll-kpi" }
const _hoisted_139 = { class: "ll-kpi" }
const _hoisted_140 = { class: "ll-seg-label" }
const _hoisted_141 = { class: "ll-seg-track" }
const _hoisted_142 = { class: "ll-crm-row" }
const _hoisted_143 = { class: "ll-m-tag ll-kick-violet" }
const _hoisted_144 = { class: "ll-spot ll-reveal ll-spot-anim" }
const _hoisted_145 = { class: "ll-spot-kicker ll-kick-teal" }
const _hoisted_146 = { class: "ll-desc" }
const _hoisted_147 = { class: "ll-checks" }
const _hoisted_148 = { class: "ll-bio-wrap" }
const _hoisted_149 = { class: "relative" }
const _hoisted_150 = { class: "ll-bphone" }
const _hoisted_151 = { class: "ll-bscreen" }
const _hoisted_152 = { class: "ll-bio-accent" }
const _hoisted_153 = { class: "ll-b-name" }
const _hoisted_154 = { class: "ll-b-handle" }
const _hoisted_155 = { class: "ll-b-link" }
const _hoisted_156 = { class: "ll-b-link ll-ghost" }
const _hoisted_157 = { class: "ll-b-link ll-ghost" }
const _hoisted_158 = { class: "ll-b-products" }
const _hoisted_159 = { class: "ll-b-prod" }
const _hoisted_160 = { class: "ll-b-prod" }
const _hoisted_161 = {
  id: "made-for-you",
  class: "mx-auto pt-24 max-w-7xl px-6 lg:px-8"
}
const _hoisted_162 = { class: "grid grid-cols-1 items-center gap-x-8 gap-y-16 lg:grid-cols-2" }
const _hoisted_163 = { class: "mx-auto w-full max-w-xl lg:mx-0" }
const _hoisted_164 = { class: "shadow inline-flex items-center rounded-full bg-white px-4 py-2 mb-8 text-base font-medium text-gray-600 ring-1 ring-gray-500/10 ring-inset" }
const _hoisted_165 = { class: "text-4xl font-semibold tracking-tight text-pretty text-gray-900 sm:text-5xl" }
const _hoisted_166 = { class: "mt-6 text-lg/8 text-gray-600" }
const _hoisted_167 = { class: "mt-8 flex items-center gap-x-6" }
const _hoisted_168 = ["href"]
const _hoisted_169 = { class: "mx-auto grid w-full max-w-xl grid-cols-5 items-center gap-y-4 gap-x-4 sm:gap-y-8 lg:mx-0 lg:max-w-none lg:pl-8" }
const _hoisted_170 = ["href"]
const _hoisted_171 = { class: "sr-only" }
const _hoisted_172 = ["src", "alt"]
const _hoisted_173 = { class: "relative mx-auto -z-10 mt-24 max-w-7xl px-6 lg:px-8" }
const _hoisted_174 = { class: "mx-auto max-w-2xl text-center" }
const _hoisted_175 = { class: "shadow inline-flex items-center rounded-full bg-white px-4 py-2 mb-8 text-base font-medium text-gray-600 ring-1 ring-gray-500/10 ring-inset" }
const _hoisted_176 = { class: "text-4xl font-semibold tracking-tight text-pretty text-gray-900 sm:text-5xl" }
const _hoisted_177 = { class: "mt-6 text-lg/8 text-gray-600" }
const _hoisted_178 = { class: "isolate mx-auto mt-10 grid grid-cols-1 gap-8 max-w-2xl" }
const _hoisted_179 = { class: "mx-auto grid w-full max-w-xl grid-cols-2 sm:grid-cols-2 md:grid-cols-3 items-center gap-y-4 gap-x-4 sm:gap-y-8" }
const _hoisted_180 = ["onClick"]
const _hoisted_181 = { class: "sr-only" }
const _hoisted_182 = ["src", "alt"]
const _hoisted_183 = ["onClick"]
const _hoisted_184 = { class: "mt-8 flex" }
const _hoisted_185 = { class: "mx-auto relative rounded-md text-center px-4 py-1.5 text-sm/8 text-gray-600 ring-1 ring-gray-900/10 ring-inset hover:ring-gray-900/20" }
const _hoisted_186 = { class: "sm:inline" }
const _hoisted_187 = { class: "ml-2 font-semibold text-teal-500" }
const _hoisted_188 = { class: "fixed inset-0 z-10 w-screen overflow-y-auto" }
const _hoisted_189 = { class: "flex min-h-full items-center justify-center p-4 text-center sm:p-0" }
const _hoisted_190 = { class: "relative w-full aspect-video" }
const _hoisted_191 = {
  class: "w-full max-w-md sm:max-w-lg aspect-[9/16]",
  controls: "",
  autoplay: "",
  muted: "",
  playsinline: ""
}
const _hoisted_192 = ["src"]
const _hoisted_193 = { class: "mt-4 text-center" }
const _hoisted_194 = {
  id: "pricing",
  class: "mx-auto pt-24 max-w-7xl px-6 lg:px-8"
}
const _hoisted_195 = { class: "mx-auto max-w-2xl lg:mx-0" }
const _hoisted_196 = { class: "shadow inline-flex items-center rounded-full bg-white px-4 py-2 mb-8 text-base font-medium text-gray-600 ring-1 ring-gray-500/10 ring-inset" }
const _hoisted_197 = { class: "text-4xl font-semibold tracking-tight text-pretty text-gray-900 sm:text-5xl" }
const _hoisted_198 = { class: "mt-6 text-lg/8 text-gray-600" }
const _hoisted_199 = { class: "isolate mx-auto mt-10 grid max-w-md grid-cols-1 gap-8 lg:mx-0 lg:max-w-none lg:grid-cols-3" }
const _hoisted_200 = { class: "flex items-center justify-between gap-x-4" }
const _hoisted_201 = ["id"]
const _hoisted_202 = {
  key: 0,
  class: "rounded-full bg-teal-600/10 px-2.5 py-1 text-xs/5 font-semibold text-teal-600"
}
const _hoisted_203 = { class: "mt-4 text-sm/8 text-gray-600" }
const _hoisted_204 = { class: "mt-6 flex items-baseline gap-x-1" }
const _hoisted_205 = { class: "text-4xl font-semibold tracking-tight text-gray-900" }
const _hoisted_206 = { class: "text-sm/8 font-semibold text-gray-600" }
const _hoisted_207 = ["href", "aria-describedby"]
const _hoisted_208 = { class: "mt-8 space-y-3 text-sm/8 text-gray-600 xl:mt-10" }
const _hoisted_209 = { class: "flex flex-col mt-8 items-start gap-x-8 gap-y-6 rounded-3xl p-8 ring-1 ring-gray-900/10 sm:gap-y-10 sm:p-10 lg:col-span-2 lg:flex-row lg:items-center" }
const _hoisted_210 = { class: "lg:min-w-0 lg:flex-1" }
const _hoisted_211 = { class: "text-base/7 font-semibold" }
const _hoisted_212 = { class: "mt-1 text-base/7 text-gray-600" }
const _hoisted_213 = {
  id: "faq",
  class: "relative mx-auto pt-24 max-w-7xl px-6 lg:px-8"
}
const _hoisted_214 = { class: "mx-auto max-w-2xl lg:mx-0" }
const _hoisted_215 = { class: "shadow inline-flex items-center rounded-full bg-white px-4 py-2 mb-8 text-base font-medium text-gray-600 ring-1 ring-gray-500/10 ring-inset" }
const _hoisted_216 = { class: "text-4xl font-semibold tracking-tight text-pretty text-gray-900 sm:text-5xl" }
const _hoisted_217 = { class: "mt-6 text-lg/8 text-gray-600" }
const _hoisted_218 = { class: "isolate mx-auto max-w-7xl grid grid-cols-1 gap-8 lg:mx-0 lg:max-w-none mt-8" }
const _hoisted_219 = { class: "divide-y divide-gray-900/10" }
const _hoisted_220 = { class: "text-base/7 font-semibold" }
const _hoisted_221 = { class: "ml-6 flex h-7 items-center" }
const _hoisted_222 = ["innerHTML"]
const _hoisted_223 = { class: "relative mx-auto pt-24 pb-8 max-w-7xl px-6 lg:px-8" }
const _hoisted_224 = { class: "ll-cta-panel ll-reveal" }
const _hoisted_225 = { class: "text-3xl sm:text-4xl font-semibold tracking-tight text-balance text-white text-center max-w-2xl mx-auto relative" }
const _hoisted_226 = ["innerHTML"]
const _hoisted_227 = { class: "mx-auto mt-6 text-lg/8 text-pretty text-teal-50 text-center max-w-xl relative" }
const _hoisted_228 = { class: "mt-10 flex items-center justify-center gap-x-6 relative" }
const _hoisted_229 = ["href"]
const _hoisted_230 = { class: "mx-auto max-w-7xl overflow-hidden px-6 py-20 sm:py-24 lg:px-8" }
const _hoisted_231 = {
  class: "-mb-6 flex flex-wrap justify-center gap-x-12 gap-y-3 text-sm/8",
  "aria-label": "Footer"
}
const _hoisted_232 = ["href"]
const _hoisted_233 = { class: "mt-16 flex justify-center gap-x-10" }
const _hoisted_234 = ["href"]
const _hoisted_235 = { class: "sr-only" }
const _hoisted_236 = { class: "flex justify-center" }
const _hoisted_237 = { class: "mt-8 text-sm/8 text-gray-600 text-center" }
const _hoisted_238 = ["innerHTML"]

import {
  defineComponent, h, ref, computed, onBeforeMount, onMounted, onUnmounted, nextTick,
} from 'vue';
import { useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';
import useAuthStore from '@/store/auth';
import HomeHeader from '@/components/tailwind/header/HomeHeader.vue';
import ChooseLanguage from '@/components/tailwind/shared/ChooseLanguage.vue';
import {
  SparklesIcon,
  BanknotesIcon,
  HeartIcon,
  PlayCircleIcon,
  XMarkIcon,
  ChatBubbleLeftEllipsisIcon,
  MinusSmallIcon,
  PlusSmallIcon,
  CheckBadgeIcon,
} from '@heroicons/vue/24/outline';
import { CheckIcon } from '@heroicons/vue/20/solid';
import {
  Dialog,
  DialogPanel,
  TransitionChild,
  TransitionRoot,
  Disclosure,
  DisclosureButton,
  DisclosurePanel,
} from '@headlessui/vue';

import BrechoEraMeuImage from '@/assets/images/customers/brechoerameu.jpg';
import JazminMais from '@/assets/images/customers/jazminmais.jpeg';
import FeiraDoLar from '@/assets/images/customers/feiradolar.jpeg';
import ElaineBrechoeOutlet from '@/assets/images/customers/elainebrechoeoutlet.jpg';
import ThomyTalks from '@/assets/images/customers/thomytalks.jpg';
import LuzdaLuaJoacaba from '@/assets/images/customers/luzdaluajoacaba.jpg';
import TaueTauBrecho from '@/assets/images/customers/tau.e.tau.brecho.jpg';
import ElvisCalcados from '@/assets/images/customers/elviscalcados.jpg';
import Lucimarmodascx from '@/assets/images/customers/lucimarmodascx.jpg';
import Elahmodafeminina from '@/assets/images/customers/elahmodafeminina.jpg';
import NovadonaMogi from '@/assets/images/customers/novadona_mogi.jpg';
import Pequenoluxo from '@/assets/images/customers/pequenoluxo.jpg';
import LojatransitoOficial from '@/assets/images/customers/lojatransito.oficial.png';
import BingaPresentes from '@/assets/images/customers/bingapresentes.jpg';
import Portobelobrechooutlet from '@/assets/images/customers/portobelobrechooutlet.jpg';


export default /*@__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {

const { t, locale } = useI18n();
const { isAuthenticated } = useAuthStore();
const router = useRouter();

/*
  Data
*/
const dataLoaded = ref(false);
const pageRoot = ref<HTMLElement | null>(null);
const showTestimonialModal = ref(false);
const activeTestimonialVideoURL = ref('');

/* Hero mockup animation state */
const liveComments = ref<Array<{ id: number; name: string; color: string; text: string }>>([]);
// Seeded with the steady-state values so the numbers read
// "healthy live" from the first frame — mobile visitors used to
// see 24 / 7 / 7 (barely-a-live) because they scroll past the
// hero before the tick loop had accumulated any activity.
// The tick loop still increments on top, so users watching
// longer see the numbers keep climbing.
const mockStats = ref({ msg: 340, cart: 85, dm: 85 });
const commentDefs = [
  { name: 'maria.moda', color: '#f472b6', key: 'c0' },
  { name: 'ju_semijoias', color: '#a78bfa', key: 'c1' },
  { name: 'carla.brecho', color: '#fbbf24', key: 'c2' },
  { name: 'dona.rosa', color: '#34d399', key: 'c3' },
  { name: 'bel.presentes', color: '#f87171', key: 'c4' },
  { name: 'lu.acessorios', color: '#60a5fa', key: 'c5' },
];
let commentIdx = 0;
let commentTimer: ReturnType<typeof setInterval> | undefined;
let revealObserver: IntersectionObserver | undefined;
let countObserver: IntersectionObserver | undefined;
let spotObserver: IntersectionObserver | undefined;

const waveHeights = [30, 55, 80, 45, 70, 35, 60, 85, 50, 75, 40, 65, 90, 45, 60, 30, 70, 55];

const customers = [
  { image: BingaPresentes, name: 'bingapresentes', href: 'https://instagram.com/bingapresentes' },
  { image: BrechoEraMeuImage, name: 'brechoerameuicara', href: 'https://instagram.com/brechoerameuicara' },
  { image: ElaineBrechoeOutlet, name: 'elainebrechoeoutlet', href: 'https://instagram.com/elainebrechoeoutlet' },
  { image: Elahmodafeminina, name: 'elahmodafeminina', href: 'https://instagram.com/elahmodafeminina' },
  { image: ElvisCalcados, name: 'elviscalcados', href: 'https://instagram.com/elviscalcados' },
  { image: FeiraDoLar, name: 'feiradolar', href: 'https://instagram.com/feiradolar' },
  { image: JazminMais, name: 'jazminmais', href: 'https://instagram.com/jazminmais' },
  { image: LuzdaLuaJoacaba, name: 'luzdaluajoaçaba', href: 'https://instagram.com/luzdaluajoacaba' },
  { image: LojatransitoOficial, name: 'lojatransito.oficial', href: 'https://instagram.com/lojatransito.oficial' },
  { image: Lucimarmodascx, name: 'lucimarmodascx', href: 'https://instagram.com/lucimarmodascx' },
  { image: NovadonaMogi, name: 'novadona_mogi', href: 'https://instagram.com/novadona_mogi' },
  { image: Pequenoluxo, name: 'pequenoluxo', href: 'https://instagram.com/pequenoluxo' },
  { image: Portobelobrechooutlet, name: 'portobelobrechooutlet', href: 'https://instagram.com/portobelobrechooutlet' },
  { image: TaueTauBrecho, name: 'tau.e.tau.brechó', href: 'https://instagram.com/tau.e.tau.brecho' },
  { image: ThomyTalks, name: 'thomytalks', href: 'https://instagram.com/thomytalks' },
];
const testimonials = [
  {
    id: 1,
    name: '@brechoerameuicara',
    href: 'https://instagram.com/brechoerameuicara',
    videoUrl: 'https://ucarecdn.com/7828318d-7073-4374-9679-d4d35dc4a38b/brechoerameuicara.mp4',
    imageUrl: BrechoEraMeuImage,
    location: 'Içara - SC',
  },
  {
    id: 2,
    name: '@feiradolar',
    href: 'https://instagram.com/feiradolar',
    videoUrl: 'https://ucarecdn.com/ef164475-214e-44e0-baf2-951907cbe807/feiradolar.mp4',
    imageUrl: FeiraDoLar,
    location: 'São José do Rio Pardo - SP',
  },
  {
    id: 3,
    name: '@jazminmais',
    href: 'https://instagram.com/jazminmais',
    videoUrl: 'https://ucarecdn.com/e291fa61-3d8e-44bf-ad1d-e6b9837aa6d8/jazminmais.mp4',
    imageUrl: JazminMais,
    location: 'Pinheiros - SP',
  },
];

/*
  Computed
*/
const landingStats = computed(() => [
  {
    label: t('home.stats.reports.title'),
    target: 11,
    decimals: 0,
    suffix: t('home.landing.stats.thousand'),
  },
  {
    label: t('home.stats.messages.title'),
    target: 5,
    decimals: 1,
    suffix: t('home.landing.stats.million'),
  },
  {
    label: t('home.stats.hours.title'),
    target: 40,
    decimals: 0,
    suffix: t('home.landing.stats.thousand'),
  },
  {
    label: t('home.stats.accounts.title'),
    target: 1,
    decimals: 0,
    suffix: t('home.landing.stats.thousand'),
  },
]);
const journeySteps = computed(() => [
  {
    emoji: '📱',
    bg: 'linear-gradient(135deg,#fdf2f8,#fce7f3)',
    color: '#db2777',
    title: t('home.landing.journey.s1t'),
    desc: t('home.landing.journey.s1d'),
  },
  {
    emoji: '🎥',
    bg: 'linear-gradient(135deg,#fff1f2,#ffe4e6)',
    color: '#e11d48',
    title: t('home.landing.journey.s2t'),
    desc: t('home.landing.journey.s2d'),
  },
  {
    emoji: '✨',
    bg: 'linear-gradient(135deg,#f5f3ff,#ede9fe)',
    color: '#7c3aed',
    title: t('home.landing.journey.s3t'),
    desc: t('home.landing.journey.s3d'),
  },
  {
    emoji: '🛒',
    bg: 'linear-gradient(135deg,#f0fdfa,#ccfbf1)',
    color: '#0f766e',
    title: t('home.landing.journey.s4t'),
    desc: t('home.landing.journey.s4d'),
  },
]);
const crmSegments = computed(() => [
  { label: t('home.landing.spots.crm.seg1'), pct: 18, bg: 'linear-gradient(90deg,#8b5cf6,#a78bfa)' },
  { label: t('home.landing.spots.crm.seg2'), pct: 34, bg: 'linear-gradient(90deg,#0d9488,#14b8a6)' },
  { label: t('home.landing.spots.crm.seg3'), pct: 31, bg: 'linear-gradient(90deg,#f59e0b,#fbbf24)' },
  { label: t('home.landing.spots.crm.seg4'), pct: 17, bg: '#d1d5db' },
]);
const faqs = computed(() => [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11].map((i) => ({
  question: t(`home.faq.questions.${i}.question`),
  answers: t(`home.faq.questions.${i}.answers`).split('\n'),
})));
const tiers = computed(() => [
  {
    name: t('home.pricing.tiers.basic.title'),
    button: t('home.pricing.tiers.basic.button'),
    id: 'tier-basic',
    href: router.resolve({ name: 'SessionSignupPage' }).href,
    price: t('home.pricing.tiers.basic.price'),
    frequency: t('home.pricing.tiers.basic.frequency'),
    description: t('home.pricing.tiers.basic.description'),
    features: t('home.pricing.tiers.basic.features'),
    mostPopular: false,
  },
  {
    name: t('home.pricing.tiers.intermediate.title'),
    button: t('home.pricing.tiers.intermediate.button'),
    id: 'tier-intermediate',
    href: router.resolve({ name: 'SessionSignupPage' }).href,
    price: t('home.pricing.tiers.intermediate.price'),
    frequency: t('home.pricing.tiers.intermediate.frequency'),
    description: t('home.pricing.tiers.intermediate.description'),
    features: t('home.pricing.tiers.intermediate.features'),
    mostPopular: false,
  },
  {
    name: t('home.pricing.tiers.subscription.title'),
    button: t('home.pricing.tiers.subscription.button'),
    id: 'tier-subscription',
    href: router.resolve({ name: 'SessionSignupPage' }).href,
    price: t('home.pricing.tiers.subscription.price'),
    frequency: t('home.pricing.tiers.subscription.frequency'),
    description: t('home.pricing.tiers.subscription.description'),
    features: t('home.pricing.tiers.subscription.features'),
    mostPopular: true,
  },
]);
const footerNavigation = computed(() => ({
  main: [
    { name: t('footer.links.terms.shoppers.name'), href: router.resolve({ name: 'TermsAndConditionsPageShoppers' }).href },
    { name: t('footer.links.terms.partners.name'), href: router.resolve({ name: 'TermsAndConditionsPage' }).href },
    { name: t('footer.links.terms.privacy.name'), href: router.resolve({ name: 'PrivacyPage' }).href },
  ],
  social: [
    {
      name: 'Instagram',
      href: 'https://www.instagram.com/livelinkoficial',
      icon: defineComponent({
        render: () => h('svg', { fill: 'currentColor', viewBox: '0 0 24 24' }, [
          h('path', {
            'fill-rule': 'evenodd',
            d: 'M12.315 2c2.43 0 2.784.013 3.808.06 1.064.049 1.791.218 2.427.465a4.902 4.902 0 011.772 1.153 4.902 4.902 0 011.153 1.772c.247.636.416 1.363.465 2.427.048 1.067.06 1.407.06 4.123v.08c0 2.643-.012 2.987-.06 4.043-.049 1.064-.218 1.791-.465 2.427a4.902 4.902 0 01-1.153 1.772 4.902 4.902 0 01-1.772 1.153c-.636.247-1.363.416-2.427.465-1.067.048-1.407.06-4.123.06h-.08c-2.643 0-2.987-.012-4.043-.06-1.064-.049-1.791-.218-2.427-.465a4.902 4.902 0 01-1.772-1.153 4.902 4.902 0 01-1.153-1.772c-.247-.636-.416-1.363-.465-2.427-.047-1.024-.06-1.379-.06-3.808v-.63c0-2.43.013-2.784.06-3.808.049-1.064.218-1.791.465-2.427a4.902 4.902 0 011.153-1.772A4.902 4.902 0 015.45 2.525c.636-.247 1.363-.416 2.427-.465C8.901 2.013 9.256 2 11.685 2h.63zm-.081 1.802h-.468c-2.456 0-2.784.011-3.807.058-.975.045-1.504.207-1.857.344-.467.182-.8.398-1.15.748-.35.35-.566.683-.748 1.15-.137.353-.3.882-.344 1.857-.047 1.023-.058 1.351-.058 3.807v.468c0 2.456.011 2.784.058 3.807.045.975.207 1.504.344 1.857.182.466.399.8.748 1.15.35.35.683.566 1.15.748.353.137.882.3 1.857.344 1.054.048 1.37.058 4.041.058h.08c2.597 0 2.917-.01 3.96-.058.976-.045 1.505-.207 1.858-.344.466-.182.8-.398 1.15-.748.35-.35.566-.683.748-1.15.137-.353.3-.882.344-1.857.048-1.055.058-1.37.058-4.041v-.08c0-2.597-.01-2.917-.058-3.96-.045-.976-.207-1.505-.344-1.858a3.097 3.097 0 00-.748-1.15 3.098 3.098 0 00-1.15-.748c-.353-.137-.882-.3-1.857-.344-1.023-.047-1.351-.058-3.807-.058zM12 6.865a5.135 5.135 0 110 10.27 5.135 5.135 0 010-10.27zm0 1.802a3.333 3.333 0 100 6.666 3.333 3.333 0 000-6.666zm5.338-3.205a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4z',
            'clip-rule': 'evenodd',
          }),
        ]),
      }),
    },
  ],
}));

/*
  Methods
*/
const signupLink = () => router.resolve({ name: 'SessionSignupPage' }).href;
const navigateWhatsapp = (message: string) => {
  window.open(`https://wa.me/+5511994991786?text=${message}`, '_blank');
};
const closeModal = () => {
  showTestimonialModal.value = false;
};
const openTestimonialVideoModal = (videoUrl: string) => {
  activeTestimonialVideoURL.value = videoUrl;
  showTestimonialModal.value = true;
};

const prefersReducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

const pushComment = () => {
  const def = commentDefs[commentIdx % commentDefs.length];
  commentIdx += 1;
  const text = t(`home.landing.mock.comments.${def.key}`);
  liveComments.value.push({
    id: commentIdx, name: def.name, color: def.color, text,
  });
  while (liveComments.value.length > 4) liveComments.value.shift();
  mockStats.value.msg += 1 + Math.floor(Math.random() * 3);
  if (/quero|want/i.test(text)) {
    mockStats.value.cart += 1;
    mockStats.value.dm += 1;
  }
};

const startHeroLoop = () => {
  if (prefersReducedMotion()) {
    for (let i = 0; i < 3; i += 1) pushComment();
    mockStats.value = { msg: 340, cart: 85, dm: 85 };
    return;
  }
  pushComment();
  commentTimer = setInterval(pushComment, 2200);
};

const animateCount = (el: HTMLElement) => {
  const node = el;
  const target = parseFloat(node.dataset.target || '0');
  const decimals = parseInt(node.dataset.decimals || '0', 10);
  const suffix = node.dataset.suffix || '';
  const loc = locale.value === 'en' ? 'en-US' : 'pt-BR';
  const fmt = (v: number) => (decimals
    ? v.toFixed(decimals).replace('.', loc === 'pt-BR' ? ',' : '.')
    : Math.round(v).toLocaleString(loc));
  if (prefersReducedMotion()) {
    node.textContent = fmt(target) + suffix;
    return;
  }
  const t0 = performance.now();
  const dur = 1400;
  const tick = (now: number) => {
    const p = Math.min((now - t0) / dur, 1);
    const ease = 1 - (1 - p) ** 4;
    node.textContent = fmt(target * ease) + suffix;
    if (p < 1) requestAnimationFrame(tick);
  };
  requestAnimationFrame(tick);
};

// Reveal-on-scroll pattern is inherently fragile: `.ll-reveal` starts
// at opacity:0 and only becomes visible when the IntersectionObserver
// adds `.ll-visible`. Any glitch (initial-dispatch race, missed layout,
// observer set up before an element is in the DOM, IntersectionObserver
// unavailable, or `pageRoot` unbound on first call) leaves that section
// permanently blank — the "sometimes 'Nossos números' and 'Como
// funciona' are empty" reports were reproductions of exactly that.
// The two safety nets below make revealing eventual-and-guaranteed.
const revealAll = () => {
  pageRoot.value?.querySelectorAll('.ll-reveal').forEach((el) => {
    el.classList.add('ll-visible');
  });
};

const initObservers = () => {
  const root = pageRoot.value;
  // If the ref hasn't bound yet (rare race with v-if + nextTick),
  // retry on the next frame. Skips the silent no-op that used to
  // brick the entire below-the-fold when this hit.
  if (!root) {
    requestAnimationFrame(initObservers);
    return;
  }

  // Fallback #1: if IntersectionObserver isn't available (very old
  // browsers) reveal everything immediately.
  if (typeof IntersectionObserver === 'undefined') {
    revealAll();
    return;
  }

  revealObserver = new IntersectionObserver((entries) => {
    entries.forEach((e) => {
      if (e.isIntersecting) {
        e.target.classList.add('ll-visible');
        revealObserver?.unobserve(e.target);
      }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
  root.querySelectorAll('.ll-reveal').forEach((el) => revealObserver?.observe(el));

  // Fallback #2: after 1.5s, force-reveal anything still hidden.
  // If the observer worked, this is a no-op (elements already have
  // `.ll-visible`). If it didn't, the seller sees the section instead
  // of a blank strip. Chosen over shorter delays so the intended
  // scroll animation still plays on normal loads.
  setTimeout(revealAll, 1500);

  countObserver = new IntersectionObserver((entries) => {
    entries.forEach((e) => {
      if (e.isIntersecting) {
        countObserver?.unobserve(e.target);
        animateCount(e.target as HTMLElement);
      }
    });
  }, { threshold: 0.6 });
  root.querySelectorAll('.ll-count').forEach((el) => countObserver?.observe(el));

  spotObserver = new IntersectionObserver((entries) => {
    entries.forEach((e) => {
      e.target.classList.toggle('ll-play', e.isIntersecting);
    });
  }, { threshold: 0.3 });
  root.querySelectorAll('.ll-spot-anim').forEach((el) => spotObserver?.observe(el));
};

/*
  Hooks
*/
onMounted(() => {
  setTimeout(() => {
    dataLoaded.value = true;
    nextTick(() => {
      initObservers();
      startHeroLoop();
    });
  }, 100);
});
onBeforeMount(() => {
  if (isAuthenticated()) {
    router.push({
      name: 'DashboardPage',
    });
  }
});
onUnmounted(() => {
  if (commentTimer) clearInterval(commentTimer);
  revealObserver?.disconnect();
  countObserver?.disconnect();
  spotObserver?.disconnect();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(HomeHeader),
    (dataLoaded.value)
      ? (_openBlock(), _createElementBlock("main", {
          key: 0,
          ref_key: "pageRoot",
          ref: pageRoot,
          class: "isolate relative"
        }, [
          _createElementVNode("div", _hoisted_1, [
            _cache[21] || (_cache[21] = _createElementVNode("div", {
              class: "ll-hero-bg absolute inset-0 -z-20",
              "aria-hidden": "true"
            }, null, -1)),
            _cache[22] || (_cache[22] = _createElementVNode("div", {
              class: "ll-hero-grid absolute inset-0 -z-10",
              "aria-hidden": "true"
            }, null, -1)),
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", null, [
                  _createElementVNode("span", _hoisted_4, [
                    _createVNode(_unref(SparklesIcon), {
                      class: "size-6 mr-2 fill-teal-500",
                      "aria-hidden": "true"
                    }),
                    _createTextVNode(" " + _toDisplayString(_unref(t)('home.hero.tag')), 1)
                  ]),
                  _createElementVNode("h1", _hoisted_5, [
                    _createTextVNode(_toDisplayString(_unref(t)('home.landing.hero.title1')) + " ", 1),
                    _createElementVNode("em", _hoisted_6, [
                      _createTextVNode(_toDisplayString(_unref(t)('home.landing.hero.titleHighlight')) + " ", 1),
                      _cache[4] || (_cache[4] = _createElementVNode("svg", {
                        viewBox: "0 0 200 10",
                        preserveAspectRatio: "none",
                        "aria-hidden": "true"
                      }, [
                        _createElementVNode("path", { d: "M2 8 Q 50 2 100 6 T 198 4" })
                      ], -1))
                    ]),
                    _createTextVNode(" " + _toDisplayString(_unref(t)('home.landing.hero.title2')), 1)
                  ]),
                  _createElementVNode("p", _hoisted_7, _toDisplayString(_unref(t)('home.landing.hero.description')), 1),
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("a", {
                      href: signupLink(),
                      class: "inline-block rounded-xl border border-transparent bg-teal-600 px-7 py-3 shadow-xl text-center font-semibold text-white hover:bg-teal-700 transition-all duration-200 focus-visible:outline-teal-600"
                    }, _toDisplayString(_unref(t)('home.hero.cta')), 9, _hoisted_9),
                    _createElementVNode("a", _hoisted_10, _toDisplayString(_unref(t)('home.landing.hero.ctaSecondary')), 1)
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("span", _hoisted_12, [
                      _cache[5] || (_cache[5] = _createElementVNode("span", { class: "ll-meta-dot" }, null, -1)),
                      _createTextVNode(" " + _toDisplayString(_unref(t)('home.landing.hero.metaBadge')), 1)
                    ]),
                    _cache[6] || (_cache[6] = _createElementVNode("span", { "aria-hidden": "true" }, "·", -1)),
                    _createElementVNode("span", null, _toDisplayString(_unref(t)('home.landing.hero.metaNote')), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _cache[11] || (_cache[11] = _createElementVNode("div", { class: "ll-phone-screen" }, null, -1)),
                    _createElementVNode("div", _hoisted_15, [
                      _cache[8] || (_cache[8] = _createElementVNode("span", { class: "ll-live-avatar" }, null, -1)),
                      _cache[9] || (_cache[9] = _createElementVNode("span", { class: "ll-live-handle" }, "@sua.loja", -1)),
                      _createElementVNode("span", _hoisted_16, [
                        _cache[7] || (_cache[7] = _createElementVNode("span", { class: "ll-dot-w" }, null, -1)),
                        _createTextVNode(_toDisplayString(_unref(t)('home.landing.mock.live')), 1)
                      ]),
                      _cache[10] || (_cache[10] = _createElementVNode("span", { class: "ll-viewers" }, "👁 1.284", -1))
                    ]),
                    _createElementVNode("div", _hoisted_17, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(liveComments.value, (c) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: c.id,
                          class: "ll-comment"
                        }, [
                          _createElementVNode("span", {
                            class: "ll-c-av",
                            style: _normalizeStyle({ background: c.color })
                          }, null, 4),
                          _createElementVNode("span", _hoisted_18, [
                            _createElementVNode("b", null, _toDisplayString(c.name), 1),
                            _createTextVNode(_toDisplayString(c.text), 1)
                          ])
                        ]))
                      }), 128))
                    ]),
                    _cache[12] || (_cache[12] = _createStaticVNode("<div class=\"ll-hearts\" data-v-42a54061><span class=\"ll-heart\" data-v-42a54061>❤️</span><span class=\"ll-heart\" data-v-42a54061>🧡</span><span class=\"ll-heart\" data-v-42a54061>💜</span><span class=\"ll-heart\" data-v-42a54061>❤️</span></div>", 1))
                  ]),
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("span", _hoisted_21, _toDisplayString(_unref(t)('home.landing.mock.report.title')), 1),
                      _createElementVNode("span", _hoisted_22, [
                        _cache[13] || (_cache[13] = _createElementVNode("span", { class: "ll-dot-pulse" }, null, -1)),
                        _createTextVNode(_toDisplayString(_unref(t)('home.landing.mock.report.realtime')), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_23, [
                      _createElementVNode("div", _hoisted_24, [
                        _createElementVNode("b", null, _toDisplayString(mockStats.value.msg), 1),
                        _createElementVNode("span", null, _toDisplayString(_unref(t)('home.landing.mock.report.messages')), 1)
                      ]),
                      _createElementVNode("div", _hoisted_25, [
                        _createElementVNode("b", null, _toDisplayString(mockStats.value.cart), 1),
                        _createElementVNode("span", null, _toDisplayString(_unref(t)('home.landing.mock.report.carts')), 1)
                      ]),
                      _createElementVNode("div", _hoisted_26, [
                        _createElementVNode("b", null, _toDisplayString(mockStats.value.dm), 1),
                        _createElementVNode("span", null, _toDisplayString(_unref(t)('home.landing.mock.report.dms')), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_27, [
                      _cache[14] || (_cache[14] = _createElementVNode("span", { class: "ll-r-ic ll-bg-amber" }, "🔥", -1)),
                      _createElementVNode("span", _hoisted_28, [
                        _createElementVNode("b", null, _toDisplayString(_unref(t)('home.landing.mock.report.hotTitle')), 1),
                        _createTextVNode(" · " + _toDisplayString(_unref(t)('home.landing.mock.report.hotDesc')), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_29, [
                      _cache[15] || (_cache[15] = _createElementVNode("span", { class: "ll-r-ic ll-bg-teal" }, "🛒", -1)),
                      _createElementVNode("span", _hoisted_30, [
                        _createElementVNode("b", null, _toDisplayString(_unref(t)('home.landing.mock.report.cartTitle')), 1),
                        _createTextVNode(" · " + _toDisplayString(_unref(t)('home.landing.mock.report.cartDesc')), 1)
                      ]),
                      _createElementVNode("span", _hoisted_31, _toDisplayString(_unref(t)('home.landing.mock.report.newBadge')), 1)
                    ]),
                    _createElementVNode("div", _hoisted_32, [
                      _cache[16] || (_cache[16] = _createElementVNode("span", { class: "ll-r-ic ll-bg-violet" }, "✨", -1)),
                      _createElementVNode("span", _hoisted_33, [
                        _createElementVNode("b", null, _toDisplayString(_unref(t)('home.landing.mock.report.iaTitle')), 1),
                        _createTextVNode(" · " + _toDisplayString(_unref(t)('home.landing.mock.report.iaDesc')), 1)
                      ]),
                      _createElementVNode("span", _hoisted_34, _toDisplayString(_unref(t)('home.landing.mock.report.iaBadge')), 1)
                    ]),
                    _createElementVNode("div", _hoisted_35, [
                      _cache[17] || (_cache[17] = _createElementVNode("span", { class: "ll-r-ic ll-bg-rose" }, "💬", -1)),
                      _createElementVNode("span", _hoisted_36, [
                        _createElementVNode("b", null, _toDisplayString(_unref(t)('home.landing.mock.report.qTitle')), 1),
                        _createTextVNode(" " + _toDisplayString(_unref(t)('home.landing.mock.report.qDesc')), 1)
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_37, [
                    _cache[19] || (_cache[19] = _createElementVNode("span", { class: "ll-dm-ic" }, "✉", -1)),
                    _createElementVNode("span", _hoisted_38, [
                      _createElementVNode("b", null, _toDisplayString(_unref(t)('home.landing.mock.dm.title')), 1),
                      _cache[18] || (_cache[18] = _createElementVNode("br", null, null, -1)),
                      _createTextVNode(_toDisplayString(_unref(t)('home.landing.mock.dm.text')), 1)
                    ]),
                    _cache[20] || (_cache[20] = _createElementVNode("span", { class: "ll-dm-check" }, "✓✓", -1))
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_39, [
            _createElementVNode("div", _hoisted_40, [
              _createElementVNode("h2", _hoisted_41, _toDisplayString(_unref(t)('home.stats.title')), 1),
              _createElementVNode("dl", _hoisted_42, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(landingStats.value, (stat) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: stat.label,
                    class: "ll-reveal ll-stat-card rounded-2xl bg-white shadow-sm ring-1 ring-gray-200 p-6"
                  }, [
                    _createElementVNode("dd", _hoisted_43, [
                      _createElementVNode("span", {
                        class: "ll-count",
                        "data-target": stat.target,
                        "data-decimals": stat.decimals,
                        "data-suffix": stat.suffix
                      }, "0", 8, _hoisted_44)
                    ]),
                    _createElementVNode("dt", _hoisted_45, _toDisplayString(stat.label), 1)
                  ]))
                }), 128))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_46, [
            _createElementVNode("span", _hoisted_47, _toDisplayString(_unref(t)('home.landing.journey.tag')), 1),
            _createElementVNode("h2", _hoisted_48, _toDisplayString(_unref(t)('home.landing.journey.title')), 1),
            _createElementVNode("p", _hoisted_49, _toDisplayString(_unref(t)('home.landing.journey.sub')), 1),
            _createElementVNode("div", _hoisted_50, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(journeySteps.value, (step, i) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: step.title,
                  class: "ll-reveal ll-step-card",
                  style: _normalizeStyle({ transitionDelay: `${i * 0.08}s` })
                }, [
                  _createElementVNode("span", _hoisted_51, _toDisplayString(i + 1), 1),
                  _createElementVNode("span", {
                    class: "ll-step-ic",
                    style: _normalizeStyle({ background: step.bg, color: step.color })
                  }, _toDisplayString(step.emoji), 5),
                  _createElementVNode("h3", _hoisted_52, _toDisplayString(step.title), 1),
                  _createElementVNode("p", _hoisted_53, _toDisplayString(step.desc), 1)
                ], 4))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_54, [
              _cache[23] || (_cache[23] = _createElementVNode("span", { class: "ll-livvia-av" }, "L", -1)),
              _createElementVNode("div", _hoisted_55, [
                _createElementVNode("b", _hoisted_56, _toDisplayString(_unref(t)('home.landing.journey.livviaName')), 1),
                _createElementVNode("div", {
                  class: "ll-livvia-bubble",
                  innerHTML: _unref(t)('home.landing.journey.livviaMsg')
                }, null, 8, _hoisted_57)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_58, [
            _createElementVNode("div", _hoisted_59, [
              _createElementVNode("div", _hoisted_60, [
                _createElementVNode("span", _hoisted_61, _toDisplayString(_unref(t)('home.landing.spots.tag')), 1),
                _createElementVNode("h2", _hoisted_62, _toDisplayString(_unref(t)('home.landing.spots.title')), 1),
                _createElementVNode("p", _hoisted_63, _toDisplayString(_unref(t)('home.landing.spots.sub')), 1)
              ]),
              _createElementVNode("div", _hoisted_64, [
                _createElementVNode("div", null, [
                  _createElementVNode("span", _hoisted_65, _toDisplayString(_unref(t)('home.landing.spots.report.kicker')), 1),
                  _createElementVNode("h3", null, _toDisplayString(_unref(t)('home.landing.spots.report.title')), 1),
                  _createElementVNode("p", _hoisted_66, _toDisplayString(_unref(t)('home.landing.spots.report.desc')), 1),
                  _createElementVNode("ul", _hoisted_67, [
                    _createElementVNode("li", null, _toDisplayString(_unref(t)('home.landing.spots.report.c1')), 1),
                    _createElementVNode("li", null, _toDisplayString(_unref(t)('home.landing.spots.report.c2')), 1),
                    _createElementVNode("li", null, _toDisplayString(_unref(t)('home.landing.spots.report.c3')), 1)
                  ])
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_68, [
                    _createElementVNode("div", _hoisted_69, [
                      _createElementVNode("span", _hoisted_70, _toDisplayString(_unref(t)('home.landing.spots.report.visTitle')), 1),
                      _createElementVNode("span", _hoisted_71, [
                        _cache[24] || (_cache[24] = _createElementVNode("span", { class: "ll-dot-pulse" }, null, -1)),
                        _createTextVNode(_toDisplayString(_unref(t)('home.landing.spots.report.pill')), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_72, [
                      _createElementVNode("span", _hoisted_73, _toDisplayString(_unref(t)('home.landing.spots.report.tab1')), 1),
                      _createElementVNode("span", _hoisted_74, _toDisplayString(_unref(t)('home.landing.spots.report.tab2')), 1),
                      _createElementVNode("span", _hoisted_75, _toDisplayString(_unref(t)('home.landing.spots.report.tab3')), 1)
                    ]),
                    _createElementVNode("div", _hoisted_76, [
                      _cache[25] || (_cache[25] = _createStaticVNode("<i style=\"height:22%;\" data-v-42a54061></i><i style=\"height:35%;\" data-v-42a54061></i><i style=\"height:28%;\" data-v-42a54061></i><i style=\"height:48%;\" data-v-42a54061></i><i style=\"height:41%;\" data-v-42a54061></i><i style=\"height:62%;\" data-v-42a54061></i>", 6)),
                      _createElementVNode("i", {
                        class: "ll-peak",
                        "data-peak": _unref(t)('home.landing.spots.report.peak'),
                        style: {"height":"100%"}
                      }, null, 8, _hoisted_77),
                      _cache[26] || (_cache[26] = _createStaticVNode("<i style=\"height:74%;\" data-v-42a54061></i><i style=\"height:52%;\" data-v-42a54061></i><i style=\"height:60%;\" data-v-42a54061></i><i style=\"height:38%;\" data-v-42a54061></i><i style=\"height:26%;\" data-v-42a54061></i>", 5))
                    ]),
                    _createElementVNode("div", _hoisted_78, [
                      _createElementVNode("div", _hoisted_79, [
                        _cache[28] || (_cache[28] = _createElementVNode("span", {
                          class: "ll-m-av",
                          style: {"background":"linear-gradient(135deg,#fbbf24,#f97316)"}
                        }, null, -1)),
                        _createElementVNode("span", null, [
                          _cache[27] || (_cache[27] = _createElementVNode("b", null, "carla.brecho", -1)),
                          _createTextVNode(" · " + _toDisplayString(_unref(t)('home.landing.spots.report.m1')), 1)
                        ]),
                        _createElementVNode("span", _hoisted_80, _toDisplayString(_unref(t)('home.landing.spots.report.tagOrder')), 1)
                      ]),
                      _createElementVNode("div", _hoisted_81, [
                        _cache[30] || (_cache[30] = _createElementVNode("span", {
                          class: "ll-m-av",
                          style: {"background":"linear-gradient(135deg,#a78bfa,#6366f1)"}
                        }, null, -1)),
                        _createElementVNode("span", null, [
                          _cache[29] || (_cache[29] = _createElementVNode("b", null, "ju_semijoias", -1)),
                          _createTextVNode(" · " + _toDisplayString(_unref(t)('home.landing.spots.report.m2')), 1)
                        ]),
                        _createElementVNode("span", _hoisted_82, _toDisplayString(_unref(t)('home.landing.spots.report.tagDoubt')), 1)
                      ]),
                      _createElementVNode("div", _hoisted_83, [
                        _cache[32] || (_cache[32] = _createElementVNode("span", {
                          class: "ll-m-av",
                          style: {"background":"linear-gradient(135deg,#f472b6,#ec4899)"}
                        }, null, -1)),
                        _createElementVNode("span", null, [
                          _cache[31] || (_cache[31] = _createElementVNode("b", null, "maria.moda", -1)),
                          _createTextVNode(" · " + _toDisplayString(_unref(t)('home.landing.spots.report.m3')), 1)
                        ]),
                        _createElementVNode("span", _hoisted_84, _toDisplayString(_unref(t)('home.landing.spots.report.tagOrder')), 1)
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_85, [
                _createElementVNode("div", null, [
                  _createElementVNode("span", _hoisted_86, _toDisplayString(_unref(t)('home.landing.spots.carts.kicker')), 1),
                  _createElementVNode("h3", null, _toDisplayString(_unref(t)('home.landing.spots.carts.title')), 1),
                  _createElementVNode("p", _hoisted_87, _toDisplayString(_unref(t)('home.landing.spots.carts.desc')), 1),
                  _createElementVNode("ul", _hoisted_88, [
                    _createElementVNode("li", null, _toDisplayString(_unref(t)('home.landing.spots.carts.c1')), 1),
                    _createElementVNode("li", null, _toDisplayString(_unref(t)('home.landing.spots.carts.c2')), 1),
                    _createElementVNode("li", null, _toDisplayString(_unref(t)('home.landing.spots.carts.c3')), 1)
                  ])
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_89, [
                    _createElementVNode("div", _hoisted_90, [
                      _createElementVNode("span", _hoisted_91, _toDisplayString(_unref(t)('home.landing.spots.carts.visTitle')), 1),
                      _createElementVNode("span", _hoisted_92, [
                        _cache[33] || (_cache[33] = _createElementVNode("span", { class: "ll-dot-pulse" }, null, -1)),
                        _createTextVNode(_toDisplayString(_unref(t)('home.landing.spots.carts.pill')), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_93, [
                      _createElementVNode("div", _hoisted_94, [
                        _cache[34] || (_cache[34] = _createElementVNode("span", { class: "ll-f-av" }, null, -1)),
                        _createElementVNode("span", _hoisted_95, [
                          _createElementVNode("b", null, _toDisplayString(_unref(t)('home.landing.spots.carts.commentBy')), 1),
                          _createTextVNode(_toDisplayString(_unref(t)('home.landing.spots.carts.comment')), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_96, [
                        _createElementVNode("div", _hoisted_97, [
                          _createTextVNode(_toDisplayString(_unref(t)('home.landing.spots.carts.cartTitle')) + " ", 1),
                          _createElementVNode("span", _hoisted_98, _toDisplayString(_unref(t)('home.landing.spots.carts.cartBadge')), 1)
                        ]),
                        _createElementVNode("div", _hoisted_99, [
                          _createElementVNode("span", null, _toDisplayString(_unref(t)('home.landing.spots.carts.item1')), 1),
                          _cache[35] || (_cache[35] = _createElementVNode("span", null, "R$ 199,00", -1))
                        ]),
                        _createElementVNode("div", _hoisted_100, [
                          _createElementVNode("span", null, _toDisplayString(_unref(t)('home.landing.spots.carts.item2')), 1),
                          _cache[36] || (_cache[36] = _createElementVNode("span", null, "R$ 0,00", -1))
                        ]),
                        _createElementVNode("div", _hoisted_101, [
                          _createElementVNode("span", null, _toDisplayString(_unref(t)('home.landing.spots.carts.total')), 1),
                          _cache[37] || (_cache[37] = _createElementVNode("span", null, "R$ 199,00", -1))
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_102, [
                        _createElementVNode("span", _hoisted_103, [
                          _createTextVNode(_toDisplayString(_unref(t)('home.landing.spots.carts.dm')), 1),
                          _createElementVNode("span", _hoisted_104, _toDisplayString(_unref(t)('home.landing.spots.carts.dmStatus')), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_105, _toDisplayString(_unref(t)('home.landing.spots.carts.note')), 1)
                    ]),
                    _createElementVNode("div", _hoisted_106, [
                      _createElementVNode("span", _hoisted_107, _toDisplayString(_unref(t)('home.landing.spots.carts.kw1')), 1),
                      _createElementVNode("span", _hoisted_108, _toDisplayString(_unref(t)('home.landing.spots.carts.kw2')), 1),
                      _createElementVNode("span", _hoisted_109, _toDisplayString(_unref(t)('home.landing.spots.carts.kw3')), 1)
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_110, [
                _createElementVNode("div", null, [
                  _createElementVNode("span", _hoisted_111, _toDisplayString(_unref(t)('home.landing.spots.ia.kicker')), 1),
                  _createElementVNode("h3", null, _toDisplayString(_unref(t)('home.landing.spots.ia.title')), 1),
                  _createElementVNode("p", _hoisted_112, _toDisplayString(_unref(t)('home.landing.spots.ia.desc')), 1),
                  _createElementVNode("ul", _hoisted_113, [
                    _createElementVNode("li", null, _toDisplayString(_unref(t)('home.landing.spots.ia.c1')), 1),
                    _createElementVNode("li", null, _toDisplayString(_unref(t)('home.landing.spots.ia.c2')), 1),
                    _createElementVNode("li", null, _toDisplayString(_unref(t)('home.landing.spots.ia.c3')), 1)
                  ])
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_114, [
                    _createElementVNode("div", _hoisted_115, [
                      _createElementVNode("span", _hoisted_116, _toDisplayString(_unref(t)('home.landing.spots.ia.visTitle')), 1),
                      _createElementVNode("span", _hoisted_117, [
                        _cache[38] || (_cache[38] = _createElementVNode("span", { class: "ll-dot-pulse" }, null, -1)),
                        _createTextVNode(_toDisplayString(_unref(t)('home.landing.spots.ia.pill')), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_118, [
                      _cache[39] || (_cache[39] = _createElementVNode("span", { class: "ll-play-btn" }, "▶", -1)),
                      _createElementVNode("span", _hoisted_119, [
                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(waveHeights, (h, i) => {
                          return _createElementVNode("i", {
                            key: i,
                            style: _normalizeStyle({ height: `${h}%`, animationDelay: `${(i % 7) * 0.05}s` })
                          }, null, 4)
                        }), 64))
                      ]),
                      _cache[40] || (_cache[40] = _createElementVNode("span", { class: "ll-p-time" }, "21h54 / 23h12", -1))
                    ]),
                    _createElementVNode("div", _hoisted_120, [
                      _cache[41] || (_cache[41] = _createElementVNode("span", { class: "ll-ts" }, "21h52", -1)),
                      _createElementVNode("span", {
                        innerHTML: _unref(t)('home.landing.spots.ia.line1')
                      }, null, 8, _hoisted_121)
                    ]),
                    _createElementVNode("div", _hoisted_122, [
                      _cache[42] || (_cache[42] = _createElementVNode("span", { class: "ll-ts" }, "21h54", -1)),
                      _createElementVNode("span", {
                        innerHTML: _unref(t)('home.landing.spots.ia.line2')
                      }, null, 8, _hoisted_123)
                    ]),
                    _createElementVNode("div", _hoisted_124, [
                      _cache[43] || (_cache[43] = _createElementVNode("span", { class: "ll-ts" }, "21h56", -1)),
                      _createElementVNode("span", {
                        innerHTML: _unref(t)('home.landing.spots.ia.line3')
                      }, null, 8, _hoisted_125)
                    ]),
                    _createElementVNode("div", _hoisted_126, [
                      _createElementVNode("span", _hoisted_127, _toDisplayString(_unref(t)('home.landing.spots.ia.chip1')), 1),
                      _createElementVNode("span", _hoisted_128, _toDisplayString(_unref(t)('home.landing.spots.ia.chip2')), 1)
                    ]),
                    _cache[44] || (_cache[44] = _createElementVNode("span", { class: "ll-prog" }, null, -1))
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_129, [
                _createElementVNode("div", null, [
                  _createElementVNode("span", _hoisted_130, _toDisplayString(_unref(t)('home.landing.spots.crm.kicker')), 1),
                  _createElementVNode("h3", null, _toDisplayString(_unref(t)('home.landing.spots.crm.title')), 1),
                  _createElementVNode("p", _hoisted_131, _toDisplayString(_unref(t)('home.landing.spots.crm.desc')), 1),
                  _createElementVNode("ul", _hoisted_132, [
                    _createElementVNode("li", null, _toDisplayString(_unref(t)('home.landing.spots.crm.c1')), 1),
                    _createElementVNode("li", null, _toDisplayString(_unref(t)('home.landing.spots.crm.c2')), 1),
                    _createElementVNode("li", null, _toDisplayString(_unref(t)('home.landing.spots.crm.c3')), 1)
                  ])
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_133, [
                    _createElementVNode("div", _hoisted_134, [
                      _createElementVNode("span", _hoisted_135, _toDisplayString(_unref(t)('home.landing.spots.crm.visTitle')), 1),
                      _createElementVNode("span", _hoisted_136, [
                        _cache[45] || (_cache[45] = _createElementVNode("span", { class: "ll-dot-pulse" }, null, -1)),
                        _createTextVNode(_toDisplayString(_unref(t)('home.landing.spots.crm.pill')), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_137, [
                      _createElementVNode("div", _hoisted_138, [
                        _cache[46] || (_cache[46] = _createElementVNode("b", null, [
                          _createElementVNode("span", {
                            class: "ll-count",
                            "data-target": "1284",
                            "data-decimals": "0",
                            "data-suffix": ""
                          }, "0")
                        ], -1)),
                        _createElementVNode("span", null, _toDisplayString(_unref(t)('home.landing.spots.crm.kpi1')), 1)
                      ]),
                      _createElementVNode("div", _hoisted_139, [
                        _cache[47] || (_cache[47] = _createElementVNode("b", null, [
                          _createElementVNode("span", {
                            class: "ll-count",
                            "data-target": "38",
                            "data-decimals": "0",
                            "data-suffix": "%"
                          }, "0")
                        ], -1)),
                        _createElementVNode("span", null, _toDisplayString(_unref(t)('home.landing.spots.crm.kpi2')), 1)
                      ])
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(crmSegments.value, (seg) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: seg.label,
                        class: "ll-seg"
                      }, [
                        _createElementVNode("div", _hoisted_140, [
                          _createElementVNode("span", null, _toDisplayString(seg.label), 1),
                          _createElementVNode("b", null, _toDisplayString(seg.pct) + "%", 1)
                        ]),
                        _createElementVNode("div", _hoisted_141, [
                          _createElementVNode("div", {
                            class: "ll-seg-fill",
                            style: _normalizeStyle({ '--w': `${seg.pct}%`, background: seg.bg })
                          }, null, 4)
                        ])
                      ]))
                    }), 128)),
                    _createElementVNode("div", _hoisted_142, [
                      _cache[49] || (_cache[49] = _createElementVNode("span", { class: "ll-crm-av" }, null, -1)),
                      _createElementVNode("span", null, [
                        _cache[48] || (_cache[48] = _createElementVNode("b", null, "maria.moda", -1)),
                        _createTextVNode(" · " + _toDisplayString(_unref(t)('home.landing.spots.crm.row')), 1)
                      ]),
                      _createElementVNode("span", _hoisted_143, _toDisplayString(_unref(t)('home.landing.spots.crm.rowBadge')), 1)
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_144, [
                _createElementVNode("div", null, [
                  _createElementVNode("span", _hoisted_145, _toDisplayString(_unref(t)('home.landing.spots.bio.kicker')), 1),
                  _createElementVNode("h3", null, _toDisplayString(_unref(t)('home.landing.spots.bio.title')), 1),
                  _createElementVNode("p", _hoisted_146, _toDisplayString(_unref(t)('home.landing.spots.bio.desc')), 1),
                  _createElementVNode("ul", _hoisted_147, [
                    _createElementVNode("li", null, _toDisplayString(_unref(t)('home.landing.spots.bio.c1')), 1),
                    _createElementVNode("li", null, _toDisplayString(_unref(t)('home.landing.spots.bio.c2')), 1),
                    _createElementVNode("li", null, _toDisplayString(_unref(t)('home.landing.spots.bio.c3')), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_148, [
                  _createElementVNode("div", _hoisted_149, [
                    _createElementVNode("div", _hoisted_150, [
                      _createElementVNode("div", _hoisted_151, [
                        _createElementVNode("div", _hoisted_152, [
                          _cache[54] || (_cache[54] = _createElementVNode("div", { class: "ll-b-av" }, " B ", -1)),
                          _createElementVNode("div", _hoisted_153, _toDisplayString(_unref(t)('home.landing.spots.bio.name')), 1),
                          _createElementVNode("div", _hoisted_154, _toDisplayString(_unref(t)('home.landing.spots.bio.handle')), 1),
                          _createElementVNode("span", _hoisted_155, _toDisplayString(_unref(t)('home.landing.spots.bio.l1')), 1),
                          _createElementVNode("span", _hoisted_156, _toDisplayString(_unref(t)('home.landing.spots.bio.l2')), 1),
                          _createElementVNode("span", _hoisted_157, _toDisplayString(_unref(t)('home.landing.spots.bio.l3')), 1),
                          _createElementVNode("div", _hoisted_158, [
                            _createElementVNode("div", _hoisted_159, [
                              _cache[50] || (_cache[50] = _createElementVNode("div", { class: "ll-b-ph" }, null, -1)),
                              _createElementVNode("b", null, _toDisplayString(_unref(t)('home.landing.spots.bio.p1')), 1),
                              _cache[51] || (_cache[51] = _createElementVNode("span", null, "R$ 199", -1))
                            ]),
                            _createElementVNode("div", _hoisted_160, [
                              _cache[52] || (_cache[52] = _createElementVNode("div", { class: "ll-b-ph" }, null, -1)),
                              _createElementVNode("b", null, _toDisplayString(_unref(t)('home.landing.spots.bio.p2')), 1),
                              _cache[53] || (_cache[53] = _createElementVNode("span", null, "R$ 119", -1))
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _cache[55] || (_cache[55] = _createElementVNode("div", {
                      class: "ll-bio-side",
                      "aria-hidden": "true"
                    }, [
                      _createElementVNode("span", {
                        class: "ll-theme-dot",
                        style: {"background":"#0d9488"}
                      }),
                      _createElementVNode("span", {
                        class: "ll-theme-dot",
                        style: {"background":"#ec4899"}
                      }),
                      _createElementVNode("span", {
                        class: "ll-theme-dot",
                        style: {"background":"#8b5cf6"}
                      })
                    ], -1))
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_161, [
            _createElementVNode("div", _hoisted_162, [
              _createElementVNode("div", _hoisted_163, [
                _createElementVNode("span", _hoisted_164, [
                  _createVNode(_unref(CheckBadgeIcon), {
                    class: "size-6 mr-2 fill-teal-500",
                    "aria-hidden": "true"
                  }),
                  _createTextVNode(" " + _toDisplayString(_unref(t)('home.trusted.tag')), 1)
                ]),
                _createElementVNode("h2", _hoisted_165, _toDisplayString(_unref(t)('home.trusted.title')), 1),
                _createElementVNode("p", _hoisted_166, _toDisplayString(_unref(t)('home.trusted.description')), 1),
                _createElementVNode("div", _hoisted_167, [
                  _createElementVNode("a", {
                    href: signupLink(),
                    class: "rounded-xl bg-teal-600 px-5 py-2.5 text-sm font-semibold text-white shadow-xl hover:bg-teal-700 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-teal-600"
                  }, _toDisplayString(_unref(t)('home.trusted.cta')), 9, _hoisted_168),
                  _createElementVNode("a", {
                    href: "#",
                    class: "text-sm font-semibold text-gray-900",
                    onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (navigateWhatsapp(_unref(t)('home.reviews.message'))), ["prevent"]))
                  }, [
                    _createTextVNode(_toDisplayString(_unref(t)('home.trusted.contact')) + " ", 1),
                    _cache[56] || (_cache[56] = _createElementVNode("span", { "aria-hidden": "true" }, "→", -1))
                  ])
                ])
              ]),
              _createElementVNode("ul", _hoisted_169, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(customers, (customer) => {
                  return _createElementVNode("li", {
                    key: customer.name
                  }, [
                    _createElementVNode("a", {
                      href: customer.href,
                      target: "_blank"
                    }, [
                      _createElementVNode("span", _hoisted_171, _toDisplayString(customer.name), 1),
                      _createElementVNode("img", {
                        class: "grayscale hover:grayscale-0 aspect-14/13 w-full rounded-2xl object-cover max-w-none shadow-xl",
                        src: customer.image,
                        alt: customer.name
                      }, null, 8, _hoisted_172)
                    ], 8, _hoisted_170)
                  ])
                }), 64))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_173, [
            _cache[58] || (_cache[58] = _createElementVNode("div", {
              class: "absolute inset-x-0 top-1/2 -z-10 flex -translate-y-1/2 transform-gpu justify-center overflow-hidden blur-[120px] sm:top-auto sm:right-[calc(50%-6rem)] sm:bottom-0 sm:translate-y-0 sm:justify-end",
              "aria-hidden": "true"
            }, [
              _createElementVNode("div", {
                class: "aspect-[1108/632] w-[72rem] flex-none bg-gradient-to-br from-[#ff7eb3] via-teal-400 to-[#ff7eb3] opacity-40",
                style: {"clip-path":"polygon(75% 50%, 90% 90%, 100% 55%, 95% 15%, 85% 12%, 70% 35%, 50% 50%, 45% 48%, 40% 30%, 48% 10%, 22% 40%, 2% 5%, 8% 50%, 22% 38%, 60% 100%, 75% 50%)"}
              })
            ], -1)),
            _createElementVNode("div", _hoisted_174, [
              _createElementVNode("span", _hoisted_175, [
                _createVNode(_unref(HeartIcon), {
                  class: "size-6 mr-2 fill-teal-500",
                  "aria-hidden": "true"
                }),
                _createTextVNode(" " + _toDisplayString(_unref(t)('home.reviews.tag')), 1)
              ]),
              _createElementVNode("h2", _hoisted_176, _toDisplayString(_unref(t)('home.reviews.title')), 1),
              _createElementVNode("p", _hoisted_177, _toDisplayString(_unref(t)('home.reviews.description')), 1)
            ]),
            _createElementVNode("div", _hoisted_178, [
              _createElementVNode("ul", _hoisted_179, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(testimonials, (testimonial) => {
                  return _createElementVNode("li", {
                    key: testimonial.name
                  }, [
                    _createElementVNode("a", {
                      href: "#",
                      onClick: _withModifiers(($event: any) => (openTestimonialVideoModal(testimonial.videoUrl)), ["prevent"])
                    }, [
                      _createElementVNode("span", _hoisted_181, _toDisplayString(testimonial.name), 1),
                      _createElementVNode("img", {
                        class: "grayscale hover:grayscale-0 aspect-14/13 w-full rounded-2xl object-cover max-w-none",
                        src: testimonial.imageUrl,
                        alt: testimonial.name
                      }, null, 8, _hoisted_182)
                    ], 8, _hoisted_180),
                    _createElementVNode("button", {
                      type: "button",
                      class: "mt-4 mx-auto flex items-center gap-x-1.5 rounded-md border-2 border-transparent px-3 py-2 text-sm font-semibold hover:text-teal-600 shadow-xs hover:border-teal-600 focus:border-teal-600 focus:outline-none",
                      onClick: ($event: any) => (openTestimonialVideoModal(testimonial.videoUrl))
                    }, [
                      _createTextVNode(_toDisplayString(_unref(t)('home.reviews.watch')) + " ", 1),
                      _createVNode(_unref(PlayCircleIcon), {
                        class: "-mr-0.5 size-5",
                        "aria-hidden": "true"
                      })
                    ], 8, _hoisted_183)
                  ])
                }), 64))
              ])
            ]),
            _createElementVNode("div", _hoisted_184, [
              _createElementVNode("p", _hoisted_185, [
                _createElementVNode("span", _hoisted_186, _toDisplayString(_unref(t)('home.reviews.cta')), 1),
                _createElementVNode("a", {
                  href: "#",
                  onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (navigateWhatsapp(_unref(t)('home.reviews.message'))), ["prevent"]))
                }, [
                  _createElementVNode("span", _hoisted_187, [
                    _createTextVNode(_toDisplayString(_unref(t)('home.reviews.contact')) + " ", 1),
                    _cache[57] || (_cache[57] = _createElementVNode("span", { "aria-hidden": "true" }, "→", -1))
                  ])
                ])
              ])
            ])
          ]),
          _createVNode(_unref(TransitionRoot), {
            as: "template",
            show: showTestimonialModal.value
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(Dialog), {
                class: "relative z-10",
                onClose: closeModal
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(TransitionChild), {
                    as: "template",
                    enter: "ease-out duration-300",
                    "enter-from": "opacity-0",
                    "enter-to": "opacity-100",
                    leave: "ease-in duration-200",
                    "leave-from": "opacity-100",
                    "leave-to": "opacity-0"
                  }, {
                    default: _withCtx(() => _cache[59] || (_cache[59] = [
                      _createElementVNode("div", { class: "fixed inset-0 bg-gray-500/75 transition-opacity" }, null, -1)
                    ])),
                    _: 1
                  }),
                  _createElementVNode("div", _hoisted_188, [
                    _createElementVNode("div", _hoisted_189, [
                      _createVNode(_unref(TransitionChild), {
                        as: "template",
                        enter: "ease-out duration-300",
                        "enter-from": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                        "enter-to": "opacity-100 translate-y-0 sm:scale-100",
                        leave: "ease-in duration-200",
                        "leave-from": "opacity-100 translate-y-0 sm:scale-100",
                        "leave-to": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(DialogPanel), { class: "relative transform overflow-hidden rounded-lg bg-white p-4 text-left shadow-xl transition-all sm:my-8 flex flex-col" }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_190, [
                                _createElementVNode("video", _hoisted_191, [
                                  _createElementVNode("source", {
                                    src: activeTestimonialVideoURL.value,
                                    type: "video/mp4"
                                  }, null, 8, _hoisted_192)
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_193, [
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "rounded-full bg-gray-600 p-1.5 text-white shadow-xs hover:bg-gray-500 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-600",
                                  onClick: closeModal
                                }, [
                                  _createVNode(_unref(XMarkIcon), {
                                    class: "size-6 text-gray-200",
                                    "aria-hidden": "true"
                                  })
                                ])
                              ])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["show"]),
          _createElementVNode("div", _hoisted_194, [
            _createElementVNode("div", _hoisted_195, [
              _createElementVNode("span", _hoisted_196, [
                _createVNode(_unref(BanknotesIcon), {
                  class: "size-6 mr-2 fill-teal-500",
                  "aria-hidden": "true"
                }),
                _createTextVNode(" " + _toDisplayString(_unref(t)('home.pricing.tag')), 1)
              ]),
              _createElementVNode("h2", _hoisted_197, _toDisplayString(_unref(t)('home.pricing.title')), 1),
              _createElementVNode("p", _hoisted_198, _toDisplayString(_unref(t)('home.pricing.description')), 1)
            ]),
            _createElementVNode("div", _hoisted_199, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tiers.value, (tier) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: tier.name,
                  class: _normalizeClass([tier.mostPopular ? 'ring-2 ring-teal-600' : 'ring-1 ring-gray-200', 'rounded-3xl p-8 xl:p-10 bg-white shadow-xl'])
                }, [
                  _createElementVNode("div", _hoisted_200, [
                    _createElementVNode("h3", {
                      id: tier.id,
                      class: _normalizeClass([tier.mostPopular ? 'text-teal-600' : 'text-gray-900', 'text-lg/8 font-semibold'])
                    }, _toDisplayString(tier.name), 11, _hoisted_201),
                    (tier.mostPopular)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_202, _toDisplayString(_unref(t)('home.pricing.mostPopular')), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("p", _hoisted_203, _toDisplayString(tier.description), 1),
                  _createElementVNode("p", _hoisted_204, [
                    _createElementVNode("span", _hoisted_205, _toDisplayString(tier.price), 1),
                    _createElementVNode("span", _hoisted_206, _toDisplayString(tier.frequency), 1)
                  ]),
                  _createElementVNode("a", {
                    href: tier.href,
                    "aria-describedby": tier.id,
                    class: _normalizeClass([tier.mostPopular ? 'bg-teal-600 text-white shadow-xs hover:bg-teal-500' : 'text-teal-600 ring-1 ring-teal-500 ring-inset hover:ring-teal-600', 'mt-6 block rounded-md px-3 py-2 text-center text-sm/8 font-semibold focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-teal-600'])
                  }, _toDisplayString(tier.button), 11, _hoisted_207),
                  _createElementVNode("ul", _hoisted_208, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tier.features.split(';'), (feature) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: feature,
                        class: "flex gap-x-3"
                      }, [
                        _createVNode(_unref(CheckIcon), {
                          class: "h-6 w-5 flex-none text-teal-500",
                          "aria-hidden": "true"
                        }),
                        _createTextVNode(" " + _toDisplayString(feature), 1)
                      ]))
                    }), 128))
                  ])
                ], 2))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_209, [
              _createElementVNode("div", _hoisted_210, [
                _createElementVNode("h3", _hoisted_211, _toDisplayString(_unref(t)('home.pricing.custom.title')), 1),
                _createElementVNode("p", _hoisted_212, _toDisplayString(_unref(t)('home.pricing.custom.description')), 1)
              ]),
              _createElementVNode("a", {
                href: "#",
                class: "rounded-md px-3.5 py-2 text-sm/8 font-semibold text-teal-600 ring-1 ring-teal-600 ring-inset hover:ring-teal-500 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-teal-600",
                onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (navigateWhatsapp(_unref(t)('home.pricing.custom.message'))), ["prevent"]))
              }, [
                _createTextVNode(_toDisplayString(_unref(t)('home.pricing.custom.cta')) + " ", 1),
                _cache[60] || (_cache[60] = _createElementVNode("span", { "aria-hidden": "true" }, "→", -1))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_213, [
            _createElementVNode("div", _hoisted_214, [
              _createElementVNode("span", _hoisted_215, [
                _createVNode(_unref(ChatBubbleLeftEllipsisIcon), {
                  class: "size-6 mr-2 fill-teal-500",
                  "aria-hidden": "true"
                }),
                _createTextVNode(" " + _toDisplayString(_unref(t)('home.faq.tag')), 1)
              ]),
              _createElementVNode("h2", _hoisted_216, _toDisplayString(_unref(t)('home.faq.title')), 1),
              _createElementVNode("p", _hoisted_217, _toDisplayString(_unref(t)('home.faq.description')), 1)
            ]),
            _createElementVNode("div", _hoisted_218, [
              _createElementVNode("dl", _hoisted_219, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(faqs.value, (faq) => {
                  return (_openBlock(), _createBlock(_unref(Disclosure), {
                    key: faq.question,
                    as: "div",
                    class: "py-6 first:pt-0 last:pb-0"
                  }, {
                    default: _withCtx(({ open }) => [
                      _createElementVNode("dt", null, [
                        _createVNode(_unref(DisclosureButton), { class: "flex w-full items-start justify-between text-left text-gray-900" }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", _hoisted_220, _toDisplayString(faq.question), 1),
                            _createElementVNode("span", _hoisted_221, [
                              (!open)
                                ? (_openBlock(), _createBlock(_unref(PlusSmallIcon), {
                                    key: 0,
                                    class: "size-6",
                                    "aria-hidden": "true"
                                  }))
                                : (_openBlock(), _createBlock(_unref(MinusSmallIcon), {
                                    key: 1,
                                    class: "size-6",
                                    "aria-hidden": "true"
                                  }))
                            ])
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _createVNode(_unref(DisclosurePanel), {
                        as: "dd",
                        class: "mt-2 pr-12"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(faq.answers, (answer) => {
                            return (_openBlock(), _createElementBlock("p", {
                              key: answer,
                              class: "text-base/7 text-gray-600",
                              innerHTML: answer
                            }, null, 8, _hoisted_222))
                          }), 128))
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_223, [
            _createElementVNode("div", _hoisted_224, [
              _createElementVNode("h2", _hoisted_225, [
                _createElementVNode("span", {
                  innerHTML: _unref(t)('home.cta.title')
                }, null, 8, _hoisted_226)
              ]),
              _createElementVNode("p", _hoisted_227, _toDisplayString(_unref(t)('home.cta.description')), 1),
              _createElementVNode("div", _hoisted_228, [
                _createElementVNode("a", {
                  href: signupLink(),
                  class: "rounded-xl bg-white px-6 py-3 text-sm font-semibold text-teal-700 shadow-xl hover:bg-teal-50 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white"
                }, _toDisplayString(_unref(t)('home.cta.cta')), 9, _hoisted_229),
                _createElementVNode("a", {
                  href: "#",
                  class: "text-sm font-semibold text-white",
                  onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (navigateWhatsapp(_unref(t)('home.reviews.message'))), ["prevent"]))
                }, [
                  _createTextVNode(_toDisplayString(_unref(t)('home.cta.contact')) + " ", 1),
                  _cache[61] || (_cache[61] = _createElementVNode("span", { "aria-hidden": "true" }, "→", -1))
                ])
              ])
            ])
          ])
        ], 512))
      : _createCommentVNode("", true),
    _createElementVNode("footer", null, [
      _createElementVNode("div", _hoisted_230, [
        _createElementVNode("nav", _hoisted_231, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(footerNavigation.value.main, (item) => {
            return (_openBlock(), _createElementBlock("a", {
              key: item.name,
              href: item.href,
              class: "text-gray-600 hover:text-gray-900"
            }, _toDisplayString(item.name), 9, _hoisted_232))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_233, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(footerNavigation.value.social, (item) => {
            return (_openBlock(), _createElementBlock("a", {
              key: item.name,
              href: item.href,
              class: "text-gray-600 hover:text-gray-800"
            }, [
              _createElementVNode("span", _hoisted_235, _toDisplayString(item.name), 1),
              (_openBlock(), _createBlock(_resolveDynamicComponent(item.icon), {
                class: "size-6",
                "aria-hidden": "true"
              }))
            ], 8, _hoisted_234))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_236, [
          _createVNode(ChooseLanguage)
        ]),
        _createElementVNode("p", _hoisted_237, [
          _createElementVNode("span", {
            innerHTML: _unref(t)('home.footer.love')
          }, null, 8, _hoisted_238)
        ])
      ])
    ])
  ], 64))
}
}

})